import styled, { css } from 'styled-components';
import { palette, Button } from 'component-library';

const FiltersNav = styled.div`
  padding: 1.125rem;
`;

const Row = styled.div`
  padding: 0.5rem 1rem;
  display: flex;
  background-color: ${palette.Grey200};
  ${({ height }) => {
    return css`
      height: ${height};
    `;
  }}
`;

const InfoContainer = styled.div`
  width: 57rem;
  display: flex;
`;

const InfoCard = styled.div`
  padding: 1.5rem;
  border-radius: 0.5rem;
  border: 1px solid ${palette.Grey300};
  background-color: ${palette.White};
  margin-right: 1rem;
  max-height: 8.375rem;
  width: 100%;
  box-shadow: 0px 1px 1px 0px rgba(26, 32, 44, 0.08),
    0px 1px 3px 1px rgba(26, 32, 44, 0.16),
    0px -1px 4px 0px rgba(26, 32, 44, 0.05);
`;

const InfoRow = styled(InfoCard)`
  width: 56rem;
  display: flex;
  flex-direction: row;
`;

const WorkOrderHeading = styled.h5`
  font-weight: 400;
  color: ${palette.Grey700};
  font-size: 0.75rem;
  line-height: 0.75rem;
  margin: 0;
  margin-bottom: 2px;
`;

const OpButton = styled(Button)`
  color: ${palette.Indigo600};
  font-size: 0.75rem;
  font-weight: 400;
  background: none;
  padding: 0;
  height: 12px;
  text-shadow: none;
`;

const WorkOrderStat = styled.div`
  color: ${palette.Grey700};
  font-weight: 600;
  font-size: 28px;
  line-height: 36px;
  margin-bottom: 0.5rem;
`;

const WorkOrderSubStat = styled(WorkOrderStat)`
  font-size: 1rem;
  line-height: 1rem;
  margin-top: 0;
  margin-bottom: 0;
`;

const Footer = styled.div`
  position: absolute;
  bottom: 0;
  width: 100%;
  height: 4.5rem;
  background-color: ${palette.White};
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding: 1rem 1.5rem;
`;

const InfoGroup = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  align-self: stretch;
  max-height: 8.375rem;
  width: 100%;
`;

const StatGroup = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  gap: 0.25rem;
`;

const StatItem = styled.div`
  width: 3rem;
`;

const InfoGroupDivider = styled.div`
  width: 1px;
  height: 100%;
  background-color: ${palette.Grey300};
  margin: 0 2.5rem;
`;

const WorkOrderCardContainer = styled.div`
  padding: 0.75rem 0;
  border-radius: 0.5rem;
  border: 1px solid ${palette.Grey300};
  background-color: ${palette.White};
  margin-bottom: 1rem;
  margin-right: 1rem;
  min-height: 9.375rem;
  min-width: 21rem;
  max-width: 21rem;
  box-shadow: 0px 1px 1px 0px rgba(26, 32, 44, 0.08),
    0px 1px 3px 1px rgba(26, 32, 44, 0.16),
    0px -1px 4px 0px rgba(26, 32, 44, 0.05);
  &:hover {
    cursor: pointer;
  }
`;

const WorkOrderCardHeading = styled.h5`
  font-weight: 600;
  color: ${palette.Indigo600};
  font-size: 0.875rem;
  margin: 0;
  padding: 0 0.75rem 0.25rem 0.75rem;
  box-sizing: border-box;
`;

const WorkOrderSubHeading = styled.h6`
  font-weight: 600;
  color: ${palette.Grey700};
  font-size: 0.625rem;
  margin: 0;
  padding: 0 0.75rem 0.5rem 0.75rem;
`;

const HorizontalDivider = styled.div`
  width: 100%;
  height: 1px;
  background-color: ${palette.Grey300};
  margin: 0.25rem 0;
`;

const WorkOrderDetails = styled.div`
  display: flex;
  flex-direction: row;
  gap: 1rem;
  padding: 0 0.75rem;
`;

const QuantityDetails = styled.div`
  width: 8.25rem;
`;

const QuantityMade = styled.div`
  font-size: 2rem;
  font-weight: 600;
  color: ${palette.Grey700};
`;

const QuantityRequired = styled.div`
  font-size: 0.875rem;
  font-weight: 600;
  color: ${palette.Grey700};
`;

const WorkOrderScheduleDetails = styled.div`
  width: 11rem;
  padding-top: 0.75rem;
`;

const StatHeading = styled.div`
  font-size: 0.625rem;
  font-weight: 400;
  color: ${palette.Grey700};
`;

const StatValue = styled.div`
  font-size: 0.625rem;
  font-weight: 600;
  color: ${palette.Grey700};
`;

const StatRow = styled.div`
  display: flex;
  flex-direction: row;
  gap: 0.5rem;
`;

const StatColumn = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`;

export {
  FiltersNav,
  Row,
  InfoContainer,
  InfoCard,
  InfoRow,
  WorkOrderHeading,
  OpButton,
  WorkOrderStat,
  WorkOrderSubStat,
  Footer,
  InfoGroup,
  StatGroup,
  StatItem,
  InfoGroupDivider,
  WorkOrderCardContainer,
  WorkOrderCardHeading,
  WorkOrderSubHeading,
  HorizontalDivider,
  WorkOrderDetails,
  QuantityDetails,
  QuantityMade,
  QuantityRequired,
  WorkOrderScheduleDetails,
  StatHeading,
  StatValue,
  StatRow,
  StatColumn,
};
